import React from "react";
import "./TopBar.css";
import UserProfileBox from "../../pages/userProfileBox/UserProfileBox";

interface TopBarProps {
  /** Optional: extra content (e.g., right buttons) */
  children?: React.ReactNode;
}

const TopBar: React.FC<TopBarProps> = ({ children }) => {
  return (
    <header className="top-bar">
      <div className="header-container">
        <div className="topbar-right">
          {children}
          <UserProfileBox />
        </div>
      </div>
    </header>
  );
};

export default TopBar;
